var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83332 32.0834H64.1666V43.942C64.1669 46.5276 64.1669 48.7553 63.9272 50.5395C63.6699 52.4513 63.0904 54.2842 61.6038 55.7705C60.1174 57.2571 58.2846 57.8367 56.3727 58.0939C54.5886 58.3337 52.3609 58.3337 49.7752 58.3334H20.2246C17.639 58.3337 15.4113 58.3337 13.6273 58.0939C11.7154 57.8367 9.88267 57.2571 8.39617 55.7705C6.90963 54.2842 6.32997 52.4513 6.07292 50.5395C5.83306 48.7553 5.83317 46.5276 5.83332 43.942V32.0834ZM14.5833 40.8334C14.5833 39.2225 15.8892 37.9167 17.5 37.9167H23.3333C24.9441 37.9167 26.25 39.2225 26.25 40.8334C26.25 42.4442 24.9441 43.75 23.3333 43.75H17.5C15.8892 43.75 14.5833 42.4442 14.5833 40.8334ZM29.1667 40.8334C29.1667 39.2225 30.4724 37.9167 32.0833 37.9167H37.9167C39.5275 37.9167 40.8333 39.2225 40.8333 40.8334C40.8333 42.4442 39.5275 43.75 37.9167 43.75H32.0833C30.4724 43.75 29.1667 42.4442 29.1667 40.8334Z",
    fill: "#0A5EC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1666 26.25V26.058C64.1669 23.4724 64.1669 21.2446 63.9272 19.4606C63.6699 17.5487 63.0904 15.716 61.6038 14.2295C60.1174 12.7429 58.2846 12.1633 56.3727 11.9062C54.5886 11.6664 52.3609 11.6665 49.7752 11.6666H20.2247C17.6391 11.6665 15.4113 11.6664 13.6273 11.9062C11.7154 12.1633 9.88267 12.7429 8.39617 14.2295C6.90963 15.716 6.32997 17.5487 6.07292 19.4606C5.83306 21.2446 5.83317 23.4724 5.83332 26.0581V26.25L64.1666 26.25Z",
    fill: "#0A5EC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCreditCard);
export default __webpack_public_path__ + "static/media/serviceCreditCard.926227e6d4c11c4b8c3e3f5fe747b1bc.svg";
export { ForwardRef as ReactComponent };